import React from 'react'
import { FaAngleLeft } from "react-icons/fa6";
import { useLocation, useNavigate } from 'react-router';

const Alerts = () => {
    const navigation = useNavigate();
    return (
        <div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    maxWidth: "770px",
                    margin: "auto"
                }}
            >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                    <FaAngleLeft onClick={() => navigation(-1)} />
                    <p style={{ marginLeft: "23px" }}>Alerts</p>
                </div>
            </div>
        </div>
    )
}

export default Alerts
